import { DropLine } from '@App/app/entities/layer/drop-line.model';
import { Component } from '@angular/core';
import { BaseLayerPropertiesComponent } from '../base-layer-properties/base-layer-properties.component';

@Component({
  selector: 'app-drop-line-properties',
  templateUrl: './drop-line-properties.component.html',
})
export class DropLinePropertiesComponent extends BaseLayerPropertiesComponent<DropLine> {}
